'use client';

import React from 'react';

import type { PhoneNumberStep } from '@/modules/authentication/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const PhoneNumber = () => {
	return (
		<Form.TextInput<PhoneNumberStep> label="Phone Number" name="phoneNumber" />
	);
};
